import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { LazyImage } from '@/components/common/admin/mobile/LazyImage';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { SVG_COMPONENTS as ADMIN_SVG_COMPONENTS } from '@/assets/admin';
import styles from '@/components/residents/propertyChat/ResidentChatWindow.styles';
import type { UploadFile } from '@/components/common/admin/mobile/FileUploadSection';
import { getFileExtension, truncateFileName } from '@/utils/common/file';

export const FileUploadBubble: React.FC<{ file: UploadFile; onDelete: () => void }> = ({ file, onDelete }) => {
  const isImage = file.type?.startsWith('image/');

  if (isImage && file.uri) {
    return (
      <View style={styles.imageUploadBubble}>
        <LazyImage
          source={{ uri: file.uri }}
          style={styles.imageUploadPreview}
          resizeMode="cover"
          placeholder={(
            <View style={styles.imageUploadPlaceholder}>
              <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={16} height={16} color={RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY} />
            </View>
          )}
        />
        <TouchableOpacity style={styles.deleteImageButton} onPress={onDelete}>
          <ADMIN_SVG_COMPONENTS.X_CIRCLE width={16} height={16} color="#ffffff" />
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.fileUploadBubble}>
      <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={32} height={32} color={RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY} />
      <View style={styles.fileUploadInfo}>
        <Text style={styles.fileUploadName}>{truncateFileName(file.name || 'File', 20)}</Text>
        <Text style={styles.fileUploadExtension}>{getFileExtension(file.name || '')}</Text>
      </View>
      <TouchableOpacity onPress={onDelete}>
        <ADMIN_SVG_COMPONENTS.X_CIRCLE width={16} height={16} color={RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY} />
      </TouchableOpacity>
    </View>
  );
};

export default FileUploadBubble;


